import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialEcomsyncItemContainerModel} from '../../../../../../models/aggregates/erp/financial';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa, BasicApiResponseModel, PagingResponseModel } from '../../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FinancialEcomsyncItemService extends BaseApiTemplateService<FinancialEcomsyncItemContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/ecomsync-items';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/ecomsync-items';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi/ecomsync-items';
    this.httpClient = http;
  }

  getLines(guid: string, visa: ApiVisa){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/backoffice-ep/lines/' +guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(UrlByCriteria, this.getHttpHeader(visa));
  }

  public getLinesByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep/lines/' + guid,
      this.getHttpHeader(visa)
    );
  }

  getLinesPromise(guid: string, visa: ApiVisa){
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria = this.apiUrl + '/backoffice-ep/lines/' +guid;
    return this.httpClient.get<BasicApiResponseModel<any>>(UrlByCriteria, this.getHttpHeader(visa)).toPromise();
  }

  public getLinesByGuidPromise(
    guid: string,
    visa: ApiVisa
  ): Promise<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(this.apiUrl + '/backoffice-ep/lines/' + guid, this.getHttpHeader(visa))
      .toPromise();
  }

  public putEcomsyncItemExt(
    dto: any,
    visa: ApiVisa,
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep/extensions/',
      dto,
      this.getHttpHeader(visa)
    );
  }

  public putEcomsyncItemExtPromise(
    dto: any,
    visa: ApiVisa,
  ): Promise<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep/extensions/',
      dto,
      this.getHttpHeader(visa)
    ).toPromise();
  }
  
}
